import { render, staticRenderFns } from "./EditorDash.vue?vue&type=template&id=2be93f08&scoped=true&"
import script from "./EditorDash.vue?vue&type=script&lang=js&"
export * from "./EditorDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be93f08",
  null
  
)

export default component.exports